export default "__VITE_ASSET__DwNpLb5O__"